import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { formatDateColumn } from '@vindr/utils/dateTime';
import { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';

const useProcedureSearchColumns = (): TableColumnsType<any> => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: '#',
      width: 40,
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      render: (_, __, index) => index + 1,
    },
    {
      title: t('Status'),
      width: 70,
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      render: (status) => t(ORDER_STATUS[status]),
    },
    {
      title: t('Order Group'),
      width: 110,
      dataIndex: 'order_group',
      key: 'order_group',
      ellipsis: true,
    },
    {
      title: t('Patient ID'),
      width: 110,
      dataIndex: ['visited_patient', 'patient_id'],
      key: 'patient_id',
      ellipsis: true,
    },
    {
      title: t('Visit ID'),
      width: 110,
      dataIndex: ['visited_patient', 'visit_id'],
      key: 'visit_id',
      ellipsis: true,
    },
    {
      title: t('Patient Name'),
      width: 200,
      dataIndex: ['visited_patient', 'name'],
      key: 'patient_name',
      ellipsis: true,
    },
    /*  {
      title: t('Age'),
      width: 40,
      dataIndex: ['visited_patient', 'age'],
      key: 'patient_age',
      ellipsis: true,

    }, */
    {
      title: t('Scheduled Date'),
      width: 150,
      dataIndex: 'scheduled_date',
      key: 'scheduled_date',
      ellipsis: true,
      render: (text) => formatDateColumn(text),
    },
    {
      title: t('Study Description'),
      width: 250,
      dataIndex: ['procedure', 'name'],
      key: 'study_desc',
      ellipsis: true,
    },
  ];
};

export default useProcedureSearchColumns;
